// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"9df2341a","131":"75c56a05","404":"3bda6210","513":"43524e4c"}[chunkId] + ".chunk.js";
};